import { Button, FileButton, createStyles } from "@mantine/core";
import { useEffect } from "react";
import upload from "../../../assets/icons/upload.svg";
import uploaded from "../../../assets/icons/check.svg";

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    button: {
      height: "3rem",
      borderRadius: '0.5rem',
      width: '100%',
      border: `1px solid ${colors.disabled.muted}`,
      background: colors.bg.default,
      ":hover": {
        background: colors.bg.muted,
      },
      ":active": {
        background: colors.bg.muted,
      },
      "& .mantine-Button-inner": {
        display: 'flex',
        gap: '0.5rem',
      },
    },
  }
});

type ReVerificationButtonProps = {
  setFileState: (file: File | null) => void;
  fileState: File | null;
  uploadText: string;
  uploadedText: string;
  onUpload: () => void;
  accept: string;
  isError:any,
  resetRef?: React.RefObject<() => void>;
  isDirectUpload:boolean
  uploadModal?: () => void;
};

const ReVerificationButton = ({
  setFileState, fileState, uploadText, uploadedText, onUpload, accept, isError, resetRef, isDirectUpload, uploadModal,
} : ReVerificationButtonProps) => {
  const { classes } = useStyles();

  useEffect(() => {
    if (isDirectUpload && fileState) {
      onUpload();
    }
  }, [fileState]);

  return isDirectUpload ? (
    <FileButton onChange={setFileState} accept={accept} resetRef={resetRef || null}>
      {(props) => (
        <Button
          leftIcon={<img src={fileState && !isError ? uploaded : upload} alt={fileState ? "uploaded" : "upload"} />}
          className={`${classes.button} ${fileState && !isError ? "text_success_default" : "text_fg_subtle"} 
          heading_2xs_semibold`}
          {...props}
        >
          {fileState && !isError ? uploadedText : uploadText }
        </Button>
      )}
    </FileButton>
  ) : (
    <Button
      leftIcon={<img src={fileState && !isError ? uploaded : upload} alt={fileState ? "uploaded" : "upload"} />}
      className={`${classes.button} ${fileState && !isError ? "text_success_default" : "text_fg_subtle"}
      heading_2xs_semibold`}
      onClick={uploadModal}
    >
      {fileState && !isError ? uploadedText : uploadText }
    </Button>
  )
}

export default ReVerificationButton
